export default "__VITE_PUBLIC_ASSET__a4540f74__"